/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { PayoutFilesCard } from "./PayoutFilesCard";
import { UploadS3Modal } from "../Modals/UploadS3Modal";
import { Col, Row, Spinner } from "react-bootstrap";
import "./Payout.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  payoutFileList,
  updatePayoutFile,
  downloadPayoutFile,
} from "../../../redux/actions/dbactions/payoutActions";
import { Header } from "../../Header";
import PayoutIcon from "../../../../assets/PayoutIcon";

const PayoutFiles = () => {
  const dispatch = useDispatch();
  const { payoutfiles, isLoading } = useSelector((state) => state.payoutlist);
  const [refresh, setRefresh] = useState(true);
  const [uploadModal, setUploadModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);

  useEffect(() => {
    if (refresh) {
      dispatch(payoutFileList(selectedId));
      setRefresh(false);
    }
  }, [dispatch, refresh]);

  // Fallback to empty array if payoutfiles or usr is undefined
  const filteredValues = payoutfiles?.usr?.rec || [];
  // const filteredValuesd = payoutfiles || [];

  const handleUpload = () => {
    if (selectedId) {
      dispatch(updatePayoutFile(selectedId, selectedTitle));
      setRefresh(true);
      setUploadModal(false);
    }
  };

  const handleDowload = () => {
    if (selectedId) {
      dispatch(downloadPayoutFile(selectedId, selectedTitle));
      setRefresh(true);
      setUploadModal(false);
      // const blob = await response.blob();
      // const url = window.URL.createObjectURL(new Blob([blob]));
      // const link = document.createElement('a');
      // link.href = url;
      // link.setAttribute('download', 'sample.pdf');
      // document.body.appendChild(link);
      // link.click();
      // link.remove();
    }
  };

  const handleUploadShow = (fileId, fileName) => {
    setUploadModal(true);
    setRefresh(false);
    setSelectedId(fileId);
    setSelectedTitle(fileName);
  };

  return (
    <div>
      <Header pageTitle="Payout Files" icon={<PayoutIcon />} />

      {isLoading ? (
        <div className="text-center">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : null}
      <div className="ser_title_b px-[16px] flex-row sm:flex-col sm:px-8 mt-4">
        <h5 className="title">Payout Files</h5>
      </div>
      <Row className="!px-4 sm:!px-8 mt-4 ">
        {filteredValues.length > 0 ? (
          filteredValues.map((item, index) => (
            <Col className="mb-3" lg={4} md={6} key={index}>
              <PayoutFilesCard
                dispatch={dispatch}
                data={item}
                handleUploadShow={() =>
                  handleUploadShow(item.svcf_id, item.svcf_filename)
                }
              />
            </Col>
          ))
        ) : (
          <Col>
            <p className="text-center">No Payout Files to display</p>
          </Col>
        )}
      </Row>
      <UploadS3Modal
        handleUpload={() => {
          handleUpload(selectedId);
          setUploadModal(false);
        }}
        show={uploadModal}
        handleClose={() => setUploadModal(false)}
        selectedId={selectedId}
        selectedTitle={selectedTitle}
        handleDowload={handleDowload}
      />
    </div>
  );
};

export default withRouter(PayoutFiles);
